<template>
  <vx-card class="overflow-hidden">
    <div slot="no-body">
      <div class="p-6 text-center">
        <div class="title">
          <h2 class="mb-1 font-bold">{{ cam.camName }}</h2>
        </div>
        <div class="camera-status">
          <div v-if="cam.connected" class="status">
            <feather-icon icon="CheckCircleIcon" svgClasses="icon" />
            <div>Connected</div>
          </div>
          <div v-else class="status disconnected">
            <feather-icon icon="XCircleIcon" svgClasses="icon" />
            <div>Disconnected</div>
          </div>
          <router-link :to="'/camera_preview/' + cam.id">
            <feather-icon
              v-if="cam.connected"
              icon="VideoIcon"
              svgClasses="cam-icon"
            />
            <feather-icon
              v-else
              icon="VideoOffIcon"
              svgClasses="cam-icon disconnected"
            />
          </router-link>
        </div>
      </div>
    </div>
  </vx-card>
</template>
<script>
export default {
  props: ["cam"],
};
</script>

<style lang="scss" scoped>
.title {
  padding-bottom: 10px;
  margin-bottom: 20px;
  border-bottom: 1px solid #eee;
}
.camera-status {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .status {
    text-align: left;
    font-size: 20pt;
    color: #37e00d;
    font-weight: 700;
    .icon {
      width: 32px;
      height: 32px;
    }
    &.disconnected {
      color: #f61c1c;
    }
  }
  .cam-icon {
    color: #000;
    width: 64px;
    height: 64px;
    &.disconnected {
      color: #a7a7a7;
    }
  }
}
</style>
